export class View {
	_parentElement;

	_pageData;

	render(data) {
		this._pageData = data;

		const markup = this._generateMarkUp();

		this._parentElement.innerHTML = '';

		console.log('_parentElement', this._parentElement);

		this._parentElement.insertAdjacentHTML('afterbegin', markup);

		this._hideNavigator();

		// this._scrollUp();
	}

	_scrollUp() {
		//the parentElement coordinates
		const lsCoords = this._parentElement.getBoundingClientRect();
		window.scrollTo({
			left: lsCoords.left + window.scrollX,
			top: lsCoords.top + window.scrollY,
			behavior: 'smooth',
		});
	}

	//Hide the
	_hideNavigator() {
		document.getElementById('navi-toggle').checked = false;
	}
}
